import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GstPanInput from "../../FirmOnboarding/Components/GstPanInput";
import UserAddressStep from "./OnboardBuyerAddress/UserAddressStep";
import { buildKycFromOperational } from "../Redux/kycDetailsBuilders";
import { backToUserDetails } from "../utils/backNavigation";

const FirmDetailsStep = ({
  onPreviewChange,
  onRequestCancel,
  onBackState,
  requestBackWith,
}) => {
  const dispatch = useDispatch();
  const selectedRole = useSelector(
    (state) => state.onboardBuyerReducer.selectedRole,
  );
  const userDetails = useSelector(
    (state) => state.onboardBuyerReducer.userDetails,
  );
  const kycDetails = useSelector(
    (state) => state.onboardBuyerReducer.kycDetails,
  );
  const operationalDetails = useSelector(
    (state) => state.FirmOnboardingReducer.operational_details,
  );

  useEffect(() => {
    dispatch({
      type: "SET_SHOW_GST_INPUT",
      payload: !!selectedRole?.onboarding_config?.is_gst_required,
    });
  }, [dispatch, selectedRole]);


  useEffect(() => {
    if (operationalDetails && !kycDetails) {
      dispatch({
        type: "SET_KYC_DETAILS",
        payload: buildKycFromOperational(operationalDetails, userDetails?.name),
      });
      dispatch({ type: "SET_KYC_METHOD", payload: "GST" });
    }
  }, [operationalDetails, kycDetails, userDetails, dispatch]);

  const [gstHasData, setGstHasData] = useState(false);
  const handleGstHasData = useCallback((v) => setGstHasData(v), []);

  useEffect(() => {
    if (kycDetails) return;
    onBackState?.({
      screen: "gst_pan",
      hasData: gstHasData,
      back: () => backToUserDetails(dispatch),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kycDetails, gstHasData]);

  if (kycDetails) {
    return (
      <UserAddressStep
        onPreviewChange={onPreviewChange}
        onRequestCancel={onRequestCancel}
        onBackState={onBackState}
        requestBackWith={requestBackWith}
      />
    );
  }

  return (
    <Box sx={{ width: "616px", maxWidth: "100%" }}>
      <GstPanInput
        justify="flex-start"
        onSuccess={() => {}}
        onHasDataChange={handleGstHasData}
      />
    </Box>
  );
};

export default FirmDetailsStep;
